import { ticketsApi } from './claims/ticketsApi';
import { clientsApi } from './clients/clientsApi';
import { contactsApi } from './contacts/contactsApi';
import { dealsApi } from './deals/dealsApi';
import { relationshipContactsApi } from './relationshipContacts/relationshipContactsApi';

export const getApi = (objectType) => {
	switch ((objectType ?? '').toUpperCase()) {
	case 'DEAL': {
		return dealsApi;  
	}
	case 'CLIENT': {
		return clientsApi;
	}
	case 'CONTACT': {
		return contactsApi;
	}
	case 'RELATIONSHIP_CONTACT': {
		return relationshipContactsApi;
	}
	case 'TICKET': {
		return ticketsApi;
	}
	default: {
		return null;
	}
	}
};
